var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    fill: "currentColor",
    width: 884.90668,
    height: 884.90668,
    viewBox: "0 0 884.90668 884.90668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,884.90667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 3487.43,3045.24 c 0.05,0 0.09,0 0.14,0 l -114,134.04 h -0.14 l 114,-134.04",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3544.48,3184.1 101.07,-118.85 0.12,0.03 -101.06,118.83 c -0.04,-0.01 -0.09,-0.01 -0.13,-0.01",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2898.14,2569.44 h 158.34 v 353.16 h -158.27 l -0.07,-353.16",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3213.07,3179.28 h -2.28 l -312.65,-0.08 c -109.64,0.04 -198.83,89.27 -198.83,198.92 0,63.38 30.35,119.28 76.67,155.74 v 152.87 c -122.79,-48.82 -209.96,-168.61 -209.96,-308.61 0,-183.17 148.99,-333.32 332.12,-333.36 l 0.07,-0.27 h 331.66 97.84 l -114.64,134.79",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3645.55,3065.25 -101.07,118.85 -365.85,430.17 V 3408.5 l 194.94,-229.22 114,-134.04 404.65,-475.8 h 175 l -421.67,495.81",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3908.14,3930.36 c -108.44,91.29 -258.22,136.97 -449.38,136.97 h -560.62 v -765.89 h 158.34 v 628.92 h 398.01 c 148.36,0 261.76,-32.45 340.23,-97.36 78.45,-64.93 117.69,-158 117.69,-279.23 0,-118.44 -39.24,-210.46 -117.69,-276.05 -32.23,-26.96 -70.68,-48.06 -114.68,-63.94 l 95.3,-112.06 c 86.73,36.03 156.36,87.26 206.61,155.67 59.18,80.58 88.8,179.38 88.8,296.38 0,159.74 -54.22,285.28 -162.61,376.59",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.645062f1ffcdd9d006a454a4dde6eaf0.svg";
export { ForwardRef as ReactComponent };